<template>
  <div id="app">
    <Vheader></Vheader>
    <div class="content">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <Vfooter></Vfooter>
  </div>
</template>

<script>
import Vheader from './components/lib/vheader'
import Vfooter from './components/lib/vfooter.vue'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  components: {Vheader, Vfooter},
  mounted () {
  }
}
</script>

<style>
html, body, div, span {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  box-sizing: border-box;
}
/* li, ul {
  list-style: none;
} */
a {
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none
}
.content{
  width: 100%;
  min-height: calc(100vh - 480px);
}
.el-icon-arrow-left{
  font-size: 40px;
}
.el-icon-arrow-right{
  font-size: 40px;
}
/* tabs */
.el-tabs__nav-wrap::after{
  height: 1px;
}
.el-tabs__active-bar{
  background-color: #001A5C;
  height: 3px;
}
.el-tabs__item.is-active {
    color: #333333;
}
.el-tabs__item:hover {
    color: #333333;
}
/* star */
.el-icon-star-on{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue